import React, { useMemo } from "react";
import PropTypes from "prop-types";
import ControlledInput from "../CustomInput/ControlledInput";
import FormField from "./FormField";

function FormControlledInput(props) {
  const { fieldProps, ...otherProps } = props;
  const type = useMemo(() => {
    return props.type ?? "text";
  }, [props.type]);
  const defaultValue = useMemo(() => {
    if (type === "text" || type === "currency" || type === "number") {
      return "";
    } else {
      return null;
    }
  }, [type]);

  return (
    <FormField
      Field={ControlledInput}
      fieldProps={({ value, onChange }) => ({
        controlled: true,
        value:
          props.fieldProps?.parseFromDatabaseValue?.(value) ??
          value ??
          props.fieldProps?.parseFromDatabaseValue?.(defaultValue) ??
          defaultValue,
        type: type,
        suffix: props.suffix ?? null,
        nullable: props.nullable ?? undefined,
        onHandleValue: (value) => {
          value = props.fieldProps?.parseToDatabaseValue?.(value) ?? value;
          onChange({ target: { value: value ? String(value) : value } }, value ? String(value) : value);
        },
        ...fieldProps,
      })}
      {...otherProps}
    />
  );
}

FormControlledInput.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  tKey: PropTypes.string, // FormField props
  tDefault: PropTypes.string, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  rules: PropTypes.object, // FormField props
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // FormField props
  fieldProps: PropTypes.object,
  type: PropTypes.string,
  suffix: PropTypes.string,
  nullable: PropTypes.bool,
};

FormControlledInput.defaultProps = {
  fieldProps: {},
};

export default FormControlledInput;
